/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-12-23 16:23:26
 * @LastEditTime: 2021-07-01 14:13:48
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LinkLibrary/index.tsx
 */
/**
 *  Migrated Link Lib
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import classnames from 'classnames';
import lodash from 'lodash';
import React, { useEffect, useState } from 'react';

import { Link, LinkModule } from '@/src/components';
import ItemWrapper from '@/src/components/Layouts/Item/Item';

import { Select } from '@/src/components/Antd';
import { EnumActionType } from '@/src/types/common/linkType';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

const Container = (props) => {
  const { children, hasWrapper, title, containerClassName } = props;
  return hasWrapper ? (
    <ItemWrapper
      title={title}
      containerClassName={css.container + ' ' + containerClassName || ''}>
      {children}
    </ItemWrapper>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

const LinkLibrary = (props) => {
  const {
    middleText,
    hideTitle,
    containerClassName,
    linkSet,
    onChange,
    data,
    title,
    error,
    disabled,
    noBottomPadding,
    mode = 'modal',
    customTitle,
    noWrapper,
    fetchProps,
    cannotAddToCart,
    unableDelete,
  } = props;

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [err, setError] = useState<string>('');

  useEffect(() => {
    setError(error);
  }, [error]);

  return (
    <Container
      {...(hideTitle
        ? {}
        : {
            title: customTitle
              ? customTitle
              : title === ''
              ? title
              : getI18n('general.linkModule.Modal.link'),
          })}
      hasWrapper={!noWrapper}
      containerClassName={classnames(css.container, containerClassName, {
        [css.noBottomPadding]: noBottomPadding,
      })}>
      {mode === 'modal' && (
        <>
          <Link
            disabled={disabled}
            value={{
              ...data,
              item: {
                ...data?.item,
                hasError: lodash.get(data, 'item.hasError') || !!error,
              },
            }}
            onChange={onChange}
            scopeVariables={get(linkSet, 'scopeVariables')}
            linkTypeFilter={get(linkSet, 'linkTypeFilter')}
            selectedLinkType={get(linkSet, 'selectedLinkType')}
            excludeLinkType={get(linkSet, 'excludeLinkType')}
            fetchProps={fetchProps}
            cannotAddToCart={cannotAddToCart}
            unableDelete={unableDelete}
          />

          {error && <div className={'errText'}>{err}</div>}
        </>
      )}
      {mode === 'no-modal' && (
        <>
          <div className={css.item}>
            <LinkModule
              middleText={middleText || ''}
              scopeVariables={get(linkSet, 'scopeVariables')}
              linkTypeFilter={get(linkSet, 'linkTypeFilter')}
              selectedLinkType={get(linkSet, 'selectedLinkType')}
              excludeLinkType={get(linkSet, 'excludeLinkType')}
              value={{
                ...data,
                item: {
                  ...data?.item,
                  hasError: lodash.get(data, 'item.hasError') || !!error,
                },
              }}
              onChange={onChange}
              fetchProps={fetchProps}
              //cannotAddToCart={cannotAddToCart}
              unableDelete={unableDelete}
            />

            {error && <div className={'errText'}>{err}</div>}
          </div>
          {data.linkType === 'Product' && (
            <div
              className={css.item}
              style={{ marginTop: '32px' }}
              data-tester-title={getI18n('general.linkModule.Modal.action')}>
              <div className={css.label}>
                {getI18n('general.linkModule.Modal.action')}
              </div>
              <Select
                size={'large'}
                disabled={disabled}
                value={data.action}
                placeholder={getI18n(
                  'general.linkModule.Modal.action_placeholder',
                )}
                onChange={(value: string) =>
                  onChange({ ...data, action: value })
                }
                options={[
                  {
                    value: EnumActionType.ProductDetail,
                    label: getI18n('general.linkModule.Modal.action_detail'),
                  },
                  {
                    value: EnumActionType.Cart,
                    label: getI18n('general.linkModule.Modal.add_shoppingcart'),
                  },
                ]}
              />
            </div>
          )}
        </>
      )}
    </Container>
  );
};
export default LinkLibrary;
